import type { InteractionType } from '@/common/types/interaction';

/**
 * Array.filter callback to remove duplicate values from an array.
 *
 * @example: myArray.filter(unique)
 */
export function unique<T>(value: T, index: number, self: T[]) {
  return self.indexOf(value) === index;
}

/**
 * Contacts don't have ID's, but they are unique on the union of their first
 * name, last name, and email. This function assembles an ID that can be shared
 * by Contacts (aka. Recipients) across CoverSheet and Documents datasets.
 */
export function assembleContactId(contact: {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}) {
  const c = contact;
  return `${c.firstName ?? ''}_${c.lastName ?? ''}_${c.email ?? ''}`;
}

export function camelCaseToWords(camelCase: string) {
  return camelCase
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase());
}

/**
 * Given an interaction type, returns the root route path name associated for it.
 *
 * Intended to be used for operations with Next router.
 *
 * @param interactionType
 * @returns the root path name for the interaction type
 */
export function interactionTypeRootPathName(
  interactionType: InteractionType | string,
): string {
  const type = `${interactionType}`.toLowerCase();

  if (type === 'clientgroup') return 'buyers';
  if (type === 'usertemplate') return 'templates';

  return `${type}s`;
}
